import React from "react";
import PropTypes from "prop-types";

export default function Toasts({
  components: {
    ToastContainer: Container,
    ToastBody: Body,
    ToastCloseButton: CloseButton
  },
  toasts,
  onClose,
  settings
}) {
  return (
    <Container>
      {toasts.map(({ id, message, variant }) => (
        <Body key={id} variant={variant || "error"}>
          <CloseButton onClick={() => onClose(id)} settings={settings} />
          {message}
        </Body>
      ))}
    </Container>
  );
}

Toasts.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      message: PropTypes.string
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  components: PropTypes.shape({
    ToastContainer: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    ToastTitle: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    ToastBody: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    ToastCloseButton: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
  }).isRequired,
  settings: PropTypes.objectOf(PropTypes.object).isRequired
};
